// extracted by mini-css-extract-plugin
module.exports = {"alert_success":"alert_alert_success__3wi02","alert_error":"alert_alert_error__1sgU3"};